import React, { useEffect, useState } from 'react';
import { adminApi } from '../../services/api';
import { Users, Store, Palmtree, UserPlus, AlertTriangle } from 'lucide-react';

export default function AdminDashboard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminApi.getDashboard()
      .then(r => setData(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="spinner" />;
  if (!data) return <p>Error al cargar datos.</p>;

  const stats = [
    { icon: Users, label: 'Empleados activos', value: data.total_employees, color: 'var(--blue-600)' },
    { icon: Store, label: 'Restaurantes', value: data.total_restaurants, color: 'var(--blue-500)' },
    { icon: Palmtree, label: 'Vacaciones pendientes', value: data.pending_vacation_requests, color: 'var(--amber-500)' },
    { icon: UserPlus, label: 'Solicitudes pendientes', value: data.pending_submissions, color: 'var(--success)' },
    { icon: AlertTriangle, label: 'Cursos vencidos', value: data.overdue_courses, color: 'var(--danger)' },
  ];

  return (
    <div>
      <div className="page-header">
        <h1>Panel de Gestión</h1>
        <p>Resumen general de la franquicia</p>
      </div>

      <div className="stats-grid">
        {stats.map((s, i) => (
          <div key={i} className="stat-card animate-in">
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
              <s.icon size={20} color={s.color} />
            </div>
            <div className="stat-card__value" style={{ color: s.color }}>{s.value}</div>
            <div className="stat-card__label">{s.label}</div>
          </div>
        ))}
      </div>

      {/* Employees by restaurant */}
      <div className="card" style={{ marginTop: 24 }}>
        <h3 className="card__title">Empleados por restaurante</h3>
        <table className="data-table">
          <thead>
            <tr>
              <th>Restaurante</th>
              <th>Código</th>
              <th>Empleados activos</th>
            </tr>
          </thead>
          <tbody>
            {data.employees_by_restaurant?.map(r => (
              <tr key={r.id}>
                <td>{r.name}</td>
                <td><span className="badge badge--info">{r.code}</span></td>
                <td>{r.count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
